import { z } from 'zod';
import { D } from '@mobily/ts-belt';
import type { DynamicProductAdGrouping } from '../../../types/definitions/vendor/graphql-schema.d';

export const groupingKeywordCopy: Record<DynamicProductAdGrouping, string> = {
  ELEVATED_CASUAL: 'elevated casual',
  EVERYDAY_CASUAL: 'everyday casual',
  MADE_TO_MOVE: 'made to move',
  NIGHT_OUT: 'night out',
  POLISHED_PROFESSIONAL: 'polished + professional',
};

const validGroupings = D.keys(groupingKeywordCopy);

export const dynamicAdsCookieSchema = z.object({
  id: z.string(),
  grouping: z.enum([validGroupings[0], ...validGroupings.slice(1)]),
  visitor_id: z.string(),
});

export type DynamicAdCookie = z.infer<typeof dynamicAdsCookieSchema>;
